import React, { useState, useEffect, useRef } from "react";

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";

const FinalPickReminderBanner = () => {
  /*
   * Main function that renders the message to remind
   * participants to pick their submissions for final scoring.
   */
  // const { title, message } = props;
  return (
    <>
      <Box>
        <Alert severity="warning" sx={{ fontSize: "15px" }}>
          {/* <AlertTitle>
             <p>
              Reminder: As stated on the challenge portal, you must select up to
              two submissions for the final private leaderboard ranking before
              the Track 1B submission deadline. Failure to make a selection will
              result in exclusion from the ranking.
            </p> 
          </AlertTitle> */}
          <p>
            As stated in the Challenge Overview, you must select up to
            two submissions for the final private leaderboard ranking before the
            Track 1B submission deadline. Failure to make a selection will
            result in exclusion from the ranking.
          </p>
        </Alert>
      </Box>
    </>
  );
};

export default FinalPickReminderBanner;
